// @vue/component
export default {
  name: 'AgentConnectionsSumPopover',

  props: {
    agentList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isPopoverVisible: false,
    };
  },
  computed: {
    isAnyAgentListElement() {
      return !(this.agentList.length === null || this.agentList.length === 0);
    },
  },

};
